<template>
    <div class="translator-output-container">
        <table class="table table-bordered translator-table">
            <thead>
                <tr>
                    <th class="th-ans-style  table-primary fw-semibold th-panel-header" style="font-size: 14px;">
                        <i class="bi bi-check2-circle me-2" aria-hidden="true"></i>
                        {{ messages.panelHeader }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <!-- Contenu traduit -->
                <tr>
                    <td>

                        <!-- Message spécifique pour le mode fichier -->
                        <div v-if="translationMode === 'file'" class="o-alert o-alert--info mb-3 mr-2 ml-2"
                            role="status">
                            <!-- Chargement en cours -->
                            <div v-if="isLoading" class="d-flex align-items-center justify-content-center py-4">
                                <div class="spinner-border text-primary" role="status">
                                    <span class="visually-hidden">Traduction en cours</span>
                                </div>
                                <span class="ms-2 text-muted">Traduction en cours</span>
                            </div>

                            <!-- Message d'info -->
                            <div v-else>
                                <div class="o-alert__icon">
                                    <svg class="svg-icon svg-circle-info" aria-hidden="true" focusable="false">
                                        <use
                                            xlink:href="/wp-content/themes/ans/design-system/svg-icons/icon-sprite.svg#circle-info">
                                        </use>
                                    </svg>
                                </div>
                                <h2 class="o-alert__title">Traduction par fichier</h2>
                                <p>Vous recevrez automatiquement un fichier Excel contenant les résultats de la
                                    traduction.</p>
                            </div>
                        </div>


                        <translator-display-output v-else :translated-text="translatedText"
                            :highlighted-terms="highlightedTerms" :translation-score="translationScore"
                            :is-loading="isLoading" :input-text="inputText" :model-id="modelId"
                            :direction="direction" />
                    </td>
                </tr>
                <tr v-show="translatedText && !isLoading && translationMode !== 'file'" data-testid="details-row">
                    <td>
                        <translator-details-output :detail-items="detailItems" />
                        <translator-others-trads-output :key="`others-${translatedText}-${autresTraductions.length}`"
                            :autres-traductions="autresTraductions" :input-text="inputText" :model-id="modelId"
                            :direction="direction" />
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import TranslatorDisplayOutput from './TranslatorDisplayOutput.vue';
import TranslatorDetailsOutput from './TranslatorDetailsOutput.vue';
import TranslatorOthersTradsOutput from './TranslatorOthersTradsOutput.vue';
import translatorConfig from '../config/translator.config.js';

export default {
    name: 'TranslatorOutput',
    components: { TranslatorDisplayOutput, TranslatorDetailsOutput, TranslatorOthersTradsOutput },
    props: {
        translatedText: {
            type: String,
            default: ''
        },
        highlightedTerms: {
            type: Array,
            default: () => []
        },
        translationScore: {
            type: Number,
            default: null
        },
        inputText: {
            type: String,
            default: ''
        },
        targetLang: {
            type: String,
            default: 'en'
        },
        isLoading: {
            type: Boolean,
            default: false
        },
        modelId: {
            type: String,
            default: null
        },
        direction: {
            type: String,
            default: null
        },
        autresTraductions: {
            type: Array,
            default: () => []
        },
        detailItems: {
            type: Array,
            default: () => []
        },
        translationMode: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            messages: translatorConfig.output.messages,
            thumbVote: null
        }
    },
    computed: {
        targetLangLabel() {
            const labels = {
                fr: 'Français',
                en: 'Anglais',
                de: 'Allemand',
                es: 'Espagnol'
            }
            return labels[this.targetLang] || this.targetLang
        }
    },
    methods: {
    }
}
</script>

<style scoped>
.translator-table {
    border-bottom-left-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
}

.output-text-display {
    min-height: 21rem !important;
    height: 21rem !important;
    overflow-y: auto !important;
    background-color: #e9ecef !important;
    white-space: pre-wrap;
    word-break: break-word;
    line-height: 1.6;
}

.highlight-term {
    background-color: #fff3cd;
    color: #664d03;
    border-radius: 3px;
    padding: 1px 3px;
    font-weight: 600;
}
</style>
